export type TrackId = 'first-stage' | 'workshop' | 'youth'

export interface Track {
    id: TrackId
    name: string
    grades: string
    description: string
    activities: string[]
}

export const TRACKS: Track[] = [
    {
        id: 'first-stage',
        name: 'הבמה הראשונה',
        grades: 'כיתות א׳–ג׳',
        description: 'היכרות שמחה עם עולם התיאטרון דרך משחקי דמיון, סיפורים ותנועה. כאן לומדים להעז, לצחוק ולהשתמש בגוף ובקול.',
        activities: ['משחקי דמיון ותנועה', 'סיפורים שהופכים לסצנות', 'עבודה ראשונה על קול והבעה']
    },
    {
        id: 'workshop',
        name: 'סדנת משחק',
        grades: 'כיתות ד׳–ו׳',
        description: 'אימפרוביזציה, בניית דמויות וסצנות קצרות. הילדים לומדים לעבוד בקבוצה, להקשיב לפרטנר ולהביא את הדמות שלהם לחיים.',
        activities: ['אימפרוביזציה ומשחקי במה', 'בניית דמויות', 'סצנות קצרות בזוגות ובקבוצות']
    },
    {
        id: 'youth',
        name: 'להקת הנוער',
        grades: 'כיתות ז׳–י״ב',
        description: 'עבודה מעמיקה על טקסט, דמות ובמה. מקום לבני נוער לבטא את עצמם, להתמודד עם האתגרים של משחק אמיתי ולבנות יחד עבודה מול קהל.',
        activities: ['ניתוח טקסט ובניית דמות', 'עבודה על סצנות ומונולוגים', 'יצירה משותפת מול קהל']
    }
]

export const GRADES = [
    { value: '1', label: 'כיתה א׳', track: 'first-stage' },
    { value: '2', label: 'כיתה ב׳', track: 'first-stage' },
    { value: '3', label: 'כיתה ג׳', track: 'first-stage' },
    { value: '4', label: 'כיתה ד׳', track: 'workshop' },
    { value: '5', label: 'כיתה ה׳', track: 'workshop' },
    { value: '6', label: 'כיתה ו׳', track: 'workshop' },
    { value: '7', label: 'כיתה ז׳', track: 'youth' },
    { value: '8', label: 'כיתה ח׳', track: 'youth' },
    { value: '9', label: 'כיתה ט׳', track: 'youth' },
    { value: '10', label: 'כיתה י׳', track: 'youth' },
    { value: '11', label: 'כיתה י״א', track: 'youth' },
    { value: '12', label: 'כיתה י״ב', track: 'youth' }
] as const

export const UNSURE_TRACK_LABEL = 'עוד לא בטוחים, נשמח להמלצה'

export const TRIAL_LIMITS = {
    name: 80,
    phone: 20,
    email: 120,
    notes: 600
}
